import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {isLogin} from '../../functions/Auth';
import Header from '../Headers/Header';
import UserHeader from '../Headers/UserHeader';

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    float:'left',
    padding: '10px',
    border:'1px solid #24618E',
    borderRadius: '5px',
    '& h5': {      
      margin: '0px 0 10px',
      '@media only screen and (max-width: 3500px)': { 
        fontSize: '16pt',       
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize: '26pt',     
      },
    },
    '& p': {
      fontFamily: 'Avenir_Medium !important'
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',
    height: 'auto ',
    width: '100%',
    float: 'left',
    background: '#fff',    
    zIndex: '1',
    marginTop: '2%',        
    '& h4': {      
      margin: '0',
      color: '#24618E',
      marginTop: '20px',
      '@media only screen and (max-width: 3500px)': { 
        fontSize: '20pt',
        marginTop: '20px',       
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize: '30pt',
        marginTop: '0px',      
      },
    },
    '& p':{
      marginTop:'10px',
    }
  },  
  tabInnerBlock:{
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'scroll',  
  },
  boldPara:{
    fontWeight: "bolder"
  },
  unorderedList:{
    marginTop: 0,
    paddingTop: 0,
    paddingLeft:'20px',
    '& li':{
      paddingLeft: '10px'
    }
  }
}));
//End Css Code ....

//Start PrivacyPolicy component code ...
 const PrivacyPolicy=()=> {
  let scHeight = window.innerHeight;
  
  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    scHeight = window.innerHeight - 165;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    scHeight = window.innerHeight - 175;
  }
  else if (window.screen.width >= 3501) {
    scHeight = window.innerHeight - 235;
  }
  else {
    scHeight = window.innerHeight - 165;
  }

  const classes = useStyles();
  const theme = useTheme();
  const [screenHeight, setScreenHeight] = React.useState(scHeight);

  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      scHeight = window.innerHeight - 175;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 3501) {
      scHeight = window.innerHeight - 235;
      setScreenHeight(scHeight);
    }
    else {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
  };
  // This code is use to change window viewport height

  return (
    <React.Fragment>
      
      { isLogin()  ? <UserHeader/> : <Header/> }
      
      <div className={classes.mainBlock}>
        <h4>DataPoint Privacy Policy</h4>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
         <div className={classes.tabInnerBlock} style={{ height: screenHeight.toString() + 'px' }}>
          <p style={{marginTop: '5px'}}> Effective 2020 </p>

          <p> This TOS of Service and Privacy Policy (the “TOS”) will tell you how you may use the
            Quality Counts Data Archive / DataPoint (“WEBSITE”), the terms of that use, what kinds
            of information we may collect about you when you visit the WEBSITE, how we may use such
            information, and your rights and liabilities in relation to Quality Counts, LLC. (“HOST”)
          </p>

          <p>
            YOU UNDERSTAND THAT THESE TERMS OF SERVICE ARE A LEGALLY BINDING DOCUMENT. BY CLICKING AND INDICATING THAT YOU AGREE TO THESE TERMS OF SERVICE, OR BY USING THE WEBSITE AFTER VIEWING THIS LANGUAGE, YOU AGREE TO BE LEGALLY BOUND BY THESE TERMS. YOU ACKNOWLEDGE THAT MANY OTHER BUSINESSES ARE CAPABLE OF PROVIDING TRAFFIC DATA AND/OR ANALYSIS. IF YOU DO NOT WANT TO BE BOUND BY THESE TERMS, YOU SHOULD OBTAIN INFORMATION ELSEWHERE OR COMMISSION YOUR OWN STUDY. YOU AGREE THAT TRAFFIC DATA IS NOT A NECESSARY GOOD OR SERVICE. YOU SPECIFICALLY AGREE TO WAIVE ANY ARGUMENT THAT ANY PROVISION OF THESE TERMS OF SERVICE IS UNCONSCIONABLE OR UNENFORCEABLE IN ANY WAY. BY AGREEING WITH THESE TERMS, YOU REPRESENT THAT YOU UNDERTAKE THESE OBLIGATIONS FREELY AND WITHOUT ANY MENTAL RESERVATION OR PURPOSE OF EVASION. YOU UNDERSTAND THAT YOUR AGREEMENT TO THESE TERMS OF SERVICE IS A MATERIAL INDUCEMENT TO THE HOST PROVIDING YOU WITH ACCESS AND USE OF THE WEBSITE AND THAT IF YOU NOTIFIED HOST THAT YOU DID NOT AGREE WITH THESE TERMS OF SERVICE OR DID NOT WISH TO BE COMPLETELY BOUND THEREBY, HOST WOULD NOT PERMIT YOU TO ACCESS OR USE THE WEBSITE. IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS OF SERVICE, PLEASE DISCONTINUE ANY USE OF THE WEBSITE IMMEDIATELY AND DO NOT UPLOAD, VIEW, DOWNLOAD, OR USE ANY DATA.
          </p>

          <p>
            By accessing, browsing and/or using the WEBSITE or other digital content within the WEBSITE, you accept, without limitation or qualification, the TOS and agree to be bound by the TOS. If you do not agree, please exit this WEBSITE immediately. Your remedy for dissatisfaction with this WEBSITE, or any products, services, content, or other information available on or through this WEBSITE, is to stop using the WEBSITE.
          </p>

          <p>
            The TOS only apply to your use of the WEBSITE. Any other websites that are linked to the WEBSITE are only provided as a convenience and are not subject to the TOS, and HOST is not responsible for the content or information-collection policies of third-party websites. Reference or links to any specific third-party organization does not constitute an endorsement by HOST or any of the HOST Members.
          </p>

          <p>
            All sales through the WEBSITE are final and no refund will be issued, except in the sole discretion of HOST. If you sell data through the WEBSITE, then HOST may, in its discretion exercised in good faith, process a refund request by another user for data you sold. You agree to be bound by HOST’s discretion in this regard and not to pursue any remedy against any party for a refund, charge reversal, or chargeback.
          </p>

          <p>
            We reserve the right to change the TOS from time to time as we deem necessary or appropriate. By using the WEBSITE after a change in the TOS, you agree to follow and be bound by the TOS as changed.
          </p>

          <h5 className={classes.boldPara}>Collection of Non-Personal Information</h5>

          <p>
            The WEBSITE may collect and store general information about you, which may include, among other things:
            <ul className={classes.unorderedList}>
              <li>
                The name of the domain or the IP address from which you access the internet (for example, aol.com if you are connecting from an America Online account);
              </li>
              <li>
                The date and time you access our service;
              </li>
              <li>The pages you visit;</li>
              <li>The internet address of any website from which you linked directly to us; and/or</li>
              <li>The name and release number of the web browser software you are using.</li>
            </ul>
          </p>

          <p> 
            Any collected information may be maintained indefinitely and used for our internal business and marketing purposes, such as assessing traffic patterns and usage of various features on the WEBSITE.
          </p>

          <h5 className={classes.boldPara}>Cookies</h5>

          <p>
            We may also use Cookies to collect information about you. A Cookie is a small text or data file that resides on the user’s hard drive and was created at the request of the web server to track specific information. We use Cookies to authenticate you as a user and to facilitate your movement through the various sections of the WEBSITE. We may use cookies to temporarily store application data. Most Internet browsers permit you to erase or block cookies. If you configure your browser to remove or reject cookies, though, you may not be able to utilize all the features or functions of our WEBSITE.
          </p>

          <h5 className={classes.boldPara}>Personal Information</h5>
          
          <p>
            You can access and browse any portion of the WEBSITE accessible without a login at any time without providing any personal information. Except for the general information listed above, we do not collect identifying information about you (such as your name, address, or telephone number) unless you voluntarily submit that information to us. If you register for a login to the WEBSITE, we will collect and retain any information you provide and use that information as we deem fit.
          </p>
          
          <p>
            In addition, HOST does not share any personally identifiable information of any individual with any third party unrelated to HOST, except in situations where we must provide information for legal purposes or investigations, if so directed by the person through a proper authorization, or as otherwise permitted by applicable law. In limited circumstances, including requests from legal authorities, we may be required by law to disclose information you submit.
          </p>
          
          <p>
            You should note that electronic communications, including secure messaging and email, are not necessarily secure against interception. Although we take precautions, such as encrypting access and messaging, we make no representations, guarantees, or assurances regarding the security of your information provided to us.
          </p>
          
          <h5 className={classes.boldPara}>Use of WEBSITE</h5>
          
          <p>
            You may use or download data from the website provided you keep unchanged all copyright and other notices. No other use of any Content is permitted.
          </p>
          
          <p>
            You agree that you will not violate any local, state, federal or international laws in using the WEBSITE or accessing any material on the WEBSITE. You agree that you will make no use of the WEBSITE that violates anyone else’s rights, including copyright, trademark, patent, trade secret, privacy, publicity or other rights.
          </p>
          
          <p>
            You acknowledge and agree that the WEBSITE is designed only for sharing data and is not provided as a professional service or as advice regarding specific projects or applications. It is not a substitute for professional design, study, or analysis.
          </p>
          
          <h5 className={classes.boldPara}>Registration</h5>
         
          <p>
            In order to access some of the services on this WEBSITE, you may be required to establish an account and password or access code that can be obtained by providing certain information and data (“Registration Data”). By registering, you agree that all information provided in the Registration Data is true and accurate and that you will maintain and update this information as required in order to keep it current, complete, and accurate. You also grant HOST the right to disclose to third parties certain Registration Data.
          </p>
          
          <p>
            You are solely responsible for maintaining the confidentiality of your password and account and for any and all statements made and acts or omissions that occur through the use of your password and account, including any mail sent and any charges incurred. Therefore, you must take steps to ensure that others do not gain access to your password and account. You may not transfer or share your account with anyone, and HOST reserves the right to immediately terminate your account in the event of any unauthorized transfer or sharing thereof.
          </p>
          
          <h5 className={classes.boldPara}>Use of WEBSITE and Storage of Material</h5>
          
          <p>
            You acknowledge that HOST may establish general practices and limits concerning use of the services available on our WEBSITE, including, without limitation, the maximum number of days that uploaded content will be retained, the maximum disk space that will be allotted on our servers on your behalf, and the maximum number of times (and the maximum duration for which) you may access the services in a given period of time. You agree that HOST has no responsibility or liability for the deletion or failure to store any content maintained or transmitted on or through this WEBSITE. You acknowledge that HOST reserves the right to terminate accounts that are inactive for an extended period of time. You further acknowledge that HOST reserves the right to change these general practices and limits at any time, in our sole discretion, with or without notice.
          </p>
          
          <p>
            For purposes of these TOS, “material” refers to all forms of communication that we may allow, including narrative descriptions, graphics (including photographs, illustrations, images, drawings, and logos), executable programs, video recordings, and audio recordings. You may not use this WEBSITE to publish material that we determine, at our sole discretion, to be unlawful, indecent, or objectionable, or which violates the restrictions described herein. HOST will not routinely monitor the contents of your online material. You are solely responsible for any information contained in your online material. However, if complaints are received regarding language, content, or graphics contained in your online material, HOST may, at its sole discretion, remove the content from its servers and terminate your account. HOST may also suspend the account, restrict access to it, or remove content from it, if necessary or appropriate.
          </p>
          
          <p>
            The accounts of HOST Members operate on shared resources. Excessive use or abuse of these shared network resources by one user may have a negative impact on all other users. Misuse of network resources in a manner that impairs network performance, including excessive consumption of CPU time, memory, disk space, and session time, is prohibited and may result in termination of your account or limitation of your activities.
          </p>
          
          <p>
            This WEBSITE is not designed or intended to be used as a disaster recovery facility or as an emergency data storage facility. Although HOST takes reasonable precautions to preserve and protect the material you upload to the WEBSITE, you should not rely on the WEBSITE as your only storage facility. You should preserve backup copies of any digital data, information, or other materials that you have uploaded. You agree not to hold HOST liable for any damage to, any deletion of, or any failure to store your files, data, or Registration Data.
          </p>
          
          <h5 className={classes.boldPara}>Disclaimer of Warranty and Liability</h5>
          
          <p>
            You acknowledge that HOST does not curate or verify the data that is uploaded by other users and assumes no liability therefore. Users are responsible for exercising their own common sense in using all data and assume all risks therefore.
          </p>
          
          <p>
            You acknowledge that HOST does not provide any guarantee or warranty regarding any data, whether provided by HOST or another HOST MEMBER, and does not represent that the data the user downloads is applicable to any particular project. Users acknowledge that they use any and all data at their own risk and that HOST is not liable for any loss or liability arising from such use, whether such loss is direct, incidental, consequential, or otherwise.
          </p>
          
          <p>
            YOUR USE OF THE WEBSITE IS AT YOUR OWN RISK.  MATERIALS, SERVICES AND OTHER INFORMATION ARE PROVIDED “AS IS” BY HOST. NEITHER HOST NOR THE HOST MEMBERS MAKE ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR USE, TITLE OR NON-INFRINGEMENT.
          </p>
          
          <p>
            NEITHER HOST NOR THE HOST MEMBERS TAKE RESPONSIBILITY FOR, AND EACH DISCLAIMS ANY AND ALL LIABILITY ARISING FROM, ANY INACCURACIES OR DEFECTS IN SOFTWARE, COMMUNICATION LINES, VIRTUAL PRIVATE NETWORK, THE INTERNET OR YOUR INTERNET SERVICE PROVIDER, ACCESS SYSTEM, COMPUTER HARDWARE OR SOFTWARE, OR ANY OTHER SERVICE OR DEVICE THAT YOU USE TO ACCESS THE WEBSITE.
          </p>
          
          <p>
            YOU ASSUME THE SOLE RISK OF TRANSMITTING YOUR INFORMATION AS IT RELATES TO THE USE OF THE WEBSITE, AND FOR ANY DATA CORRUPTIONS, INTENTIONAL INTERCEPTIONS, INTRUSIONS OR UNAUTHORIZED ACCESS TO INFORMATION, OR OF ANY DELAYS, INTERRUPTIONS TO OR FAILURES PREVENTING THE USE OF THE WEBSITE. YOU ACKNOWLEDGE AND AGREE THAT HOST DOES NOT GUARANTEE AGAINST VIRUSES, WORMS, OR OTHER UNAUTHORIZED USERS OR HACKERS ATTEMPTING TO OBTAIN ACCESS TO THE WEBSITE OR INFORMATION TRANSMITTED TO OR FROM THE WEBSITE.
          </p>
          
          <p>
            IN NO EVENT SHALL HOST OR THE HOST MEMBERS BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, CONSEQUENTIAL OR MONETARY DAMAGES, INCLUDING FEES AND PENALTIES, IN CONNECTION WITH YOUR USE OF MATERIALS POSTED ON THE WEBSITE OR CONNECTIVITY TO OR FROM THE WEBSITE TO ANY OTHER WEBSITE.
          </p>
          
          <h5 className={classes.boldPara}>Sensitive Information</h5>
          
          <p>
            We ask that you not send us, and you not disclose, any sensitive Personal Information (e.g., information related to racial or ethnic origin, political opinions, religion or other beliefs, health or medical condition or criminal background) on or through the WEBSITE or otherwise to us.
          </p>
          
          <h5 className={classes.boldPara}>Accessing, Changing or Suppressing Your Personal Information</h5>
          
          <p>
            To review, correct, update, suppress, delete, or otherwise limit our use of your Personal Information that you previously provided us, please email, call, or write us using the contact information listed below in the “Contact” webpage and clearly describe your reques         t.
          </p>
          
          <p>
            In your request, please make clear what information you would like to have changed, whether you would like to have your Personal Information suppressed from our database, or otherwise let us know what limitations you would like to put on our use of your Personal Information. We will try to comply with your request as soon as reasonably practicable.
          </p>
          
          <h5 className={classes.boldPara}>"Do Not Track" Signals Under California Online Privacy Protection Act (CalOPPA)
          </h5>
          
          <p>
            We do not support Do Not Track (“DNT”). Do Not Track is a preference you can set in your web browser to inform WEBSITEs that you do not want to be tracked. You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.
          </p>
          
          <h5 className={classes.boldPara}>Intellectual Property Rights</h5>
          
          <p>
            Unless otherwise expressly noted, you should assume the Content of the WEBSITE is copyright, trademark, trade dress or other intellectual property owned or licensed by HOST and/or the HOST Members. The Content includes, without limitation, images, illustrations, designs, icons, photographs, trademarks, logos, text, data, sounds, music, the WEBSITE as a whole and any other materials on the WEBSITE.
          </p>
          
          <p>
            Nothing in the TOS transfers to you any right, title or interest in any Content, including any intellectual property or content of third parties included on the WEBSITE.         
          </p>
          
          <p>
            You are only permitted to use the Content as expressly authorized by HOST or the specific content provider. Except for a single copy made for personal use only, you may not copy, reproduce, modify, republish, upload, post, transmit, or distribute any documents or information from this WEBSITE in any form or by any means without prior written permission from HOST or the specific content provider, and you are solely responsible for obtaining permission before reusing any copyrighted material that is available on this WEBSITE. Any unauthorized use of the materials appearing on this WEBSITE may violate copyright, trademark, and other applicable laws and could result in criminal or civil penalties.
          </p>
          
          <p>
            HOST does not warrant or represent that your use of Content or materials displayed on, or obtained through, this WEBSITE will not infringe the rights of third parties.
          </p>
          
          <p>
            Any purchase on the WEBSITE provides only a license to use the information. HOST or its HOST MEMBER retains authorship, right, title, ownership, and all other rights to the data and analysis performed and may use and continue to sell the information for all lawful purposes.          
          </p>
          
          <p>
            Each time you submit any User Materials (as explained further below), you represent and warrant that (a) you are at least the age of majority in the state in which you reside as to that User Material, (b) you are the sole author and owner of the intellectual property and other rights to the User Material, or you have a lawful right to submit the User Material and grant HOST the rights to it that you are granting by these TOS and any additional TOS, all without any obligation on our part to obtain consent of any third party and without creating any obligation or liability of HOST; (c) the User Material is accurate; (d) the User Material does not and, as to HOST’s permitted uses and exploitation set forth in these TOS, will not infringe any intellectual property or other right of any third party, including any contractual confidentiality right or trade secret; and (e) the User Materials will not violate these TOS or any additional TOS, or cause injury or harm to any person.
          </p>
          
          <p>
            You agree to indemnify HOST and hold HOST harmless for any losses or liability, including settlements, fines, judgments, attorney fees, and litigation costs, arising from any breach of these TOS.
          </p>
          
          <p>
            HOST has no obligation to monitor or enforce your intellectual property rights to your User Materials, but you grant HOST the right to protect and enforce HOST’s rights to your User Material, including by bringing and controlling actions in your name and on your behalf (at HOST’s cost and expense, to which you hereby consent and irrevocably appoint HOST as your attorney-in-fact, with the power of substitution and delegation, which appointment is coupled with an interest).
          </p>
          
          <h5 className={classes.boldPara}>User’s Materials</h5>
          
          <p>
            Subject to these TOS, any communication or material that you transmit to this WEBSITE or to HOST, whether by electronic mail or other means, for any reason, will be treated as nonconfidential and nonproprietary. While you retain all rights in such communications or material, you grant HOST and its designated licensees a nonexclusive, royalty-free, fully paid, perpetual, and worldwide right to copy, distribute, display, perform, publish, translate, adapt, modify, and otherwise use such material. Any grant of such licenses to other users is subject to the TOS set by HOST and/or negotiated between users.
          </p>
          
          <p>
            Please do not submit confidential or proprietary information to HOST unless we have mutually agreed in writing otherwise. HOST is also unable to accept your unsolicited ideas or proposals, so please do not submit them to HOST in any circumstance.          
          </p>
          
          <p>
            HOST respects the intellectual property of others and asks you to do the same. If you or any user of this WEBSITE believes its copyright, trademark, or other property rights have been infringed by a posting on this WEBSITE, you or the user should send notification to HOST immediately. To be effective, the notification must include:
          </p>

          <p>
            <ol className={classes.unorderedList}>
              <li>
                A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed;
              </li>
              <li>
                Identification of the copyrighted work claimed to have been infringed;
              </li>
              <li>
                Information reasonably sufficient to permit HOST to contact the complaining party, such as address, telephone number and, if available, an electronic mail address at which the complaining party may be contacted;
              </li>
              <li>
                Identification of the material that is claimed to be infringing or to be subject to infringing activity and that is to be removed and information reasonably sufficient to permit HOST to locate the materials;
              </li>
              <li>
                A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, agent, or the law; and
              </li>
              <li>
                A statement that the information in the notification is accurate and, under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.
              </li>
            </ol>
          </p>
          
          <p>
            Pursuant to the Digital Millennium Copyright Act, 17 U.S.C. Sec. 512(c), HOST’s Designated Agent for notice of claims of copyright infringement can be reached as indicated below. Service of repeat infringers of copyright or of users about whom repeat claims of copyright infringement are received will be terminated.
          </p>
          
          <p>
            Designated Agent for Claimed Infringement:
          </p>
          
          <p>
            Michael Beltran, Esq. <br />
            Curran Antonelli, LLP <br />
            400 North Tampa Street <br />
            15th Floor <br />
            Tampa, Florida 33602 <br />
          </p>
          
          <h5 className={classes.boldPara}>Transfer of Data</h5>
          
          <p>
            Your information may be transferred to and maintained on computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. In all events, the Choice of Law Provision in this Agreement shall govern.
          </p>
          
          <p>
            If you are located outside United States and choose to provide information to us, please note that we transfer the data to the United States and process it here. Your consent to these TOS followed by your submission of such information represents your agreement to that transfer.
          </p>
          
          <h5 className={classes.boldPara}>Disputes; Governing Law; Exclusive Jurisdiction; Jury Trial and Class Action Waiver
          </h5>
          
          <p>
            The laws of the State of Florida will apply to the TOS, without regard to provisions governing conflicts of laws, and all disputes, claims or proceedings must be brought exclusively in the courts of the Thirteenth Judicial Circuit in and for Hillsborough County, Florida, or the United States Federal District Court for the Middle District of Florida, Tampa Division, as applicable. Each of the Parties hereto hereby waives, on behalf of itself and its successors and assigns, any and all right to argue that the choice of forum provision is or has become unreasonable in any legal proceeding.
          </p>
          
          <p>
            THE PARTIES KNOWINGLY AND VOLUNTARILY WAIVE ANY RIGHT TO TRIAL BY JURY IN ANY PROCEEDING ARISING OUT OF OR IN ANY WAY RELATED TO THIS AGREEMENT OR THE PARTIES’ RELATIONSHIP HEREUNDER. THIS PROVISION SHALL SURVIVE THE EXPIRATION OR EARLIER TERMINATION OF THIS AGREEMENT.
          </p>
          
          <p>
            Your remedy for any dispute arising out of use of this WEBSITE is to stop using the WEBSITE. If this limitation on remedy is for any reason not upheld by a court, then you agree that any remedy shall be limited to removal of your information from the WEBSITE and a refund of any monies paid by you to HOST in exchange for use of the WEBSITE.
          </p>
          
          <h5 className={classes.boldPara}>
            THE PARTIES AGREE THAT ANY CLAIMS WILL BE ADJUDICATED ON AN INDIVIDUAL BASIS, AND EACH WAIVES THE RIGHT TO PARTICIPATE IN A CLASS, COLLECTIVE, PAGA, OR OTHER JOINT ACTION WITH RESPECT TO THE CLAIMS.
          </h5>
          
          <h5 className={classes.boldPara}>Notices</h5>
          
          <p>
            If you need to provide written notices to HOST, please mail and email to:
          </p>
          
          <p>
            Michael Beltran, Esq. <br />
            Curran Antonelli, LLP <br />
            400 North Tampa Street <br />
            15th Floor <br />
            Tampa, Florida 33602 <br />
          </p>
          
          <h5 className={classes.boldPara}>Third-Party Suppliers</h5>
          
          <p>
            HOST may use suppliers, such as software companies, to provide, support and maintain the WEBSITE. These suppliers are protected under the TOS as intended third-party beneficiaries.
          </p>
          
          <h5 className={classes.boldPara}>Indemnification</h5>
          
          <p>
            You agree to defend, indemnify and hold HOST, the HOST Members, and each of its officers, directors, physicians, employees, and agents harmless from any and all claims, liabilities, losses, damages, settlements, judgments, costs and expenses, including attorneys’ fees, arising in any way from your use of or access to the WEBSITE.
          </p>
          
          <h5 className={classes.boldPara}>Termination of Use</h5>
          
          <p>
            You agree that HOST may, in its sole discretion, terminate or suspend your access to all or part of the WEBSITE with or without notice and for any reason, including, without limitation, breach of these TOS. Any suspected fraudulent, abusive, or illegal activity may be grounds for terminating your access and may be referred to appropriate law enforcement authorities.
          </p>
          
          <p>
            Upon termination or suspension, regardless of the reasons therefore, your right to use the WEBSITE immediately ceases, and you acknowledge and agree that HOST may immediately deactivate or delete your account and all related information and files in your account and/or bar any further access to such files or this WEBSITE. HOST shall not be liable to you or any third party for any claims or damages arising out of any termination or suspension or any other actions taken by HOST in connection therewith.
          </p>
          
          <p>
            Your obligations to HOST will continue upon termination of your rights under the TOS, including restrictions regarding the content, disclaimers, indemnification obligations and liability limitations under the TOS.
          </p>
          
          <h5 className={classes.boldPara}>Severability</h5>
          
          <p>
            If any part of these TOS is held invalid or unenforceable, that portion shall be construed in a manner consistent with applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remaining portions shall remain in full force and effect.
          </p>
          
          <h5 className={classes.boldPara}>Waiver</h5>
          
          <p>
            Any failure by HOST to enforce or exercise any provision of these TOS or related rights shall not constitute a waiver of that right or provision.
          </p>
          
          <h5 className={classes.boldPara}>Miscellaneous</h5>
          
          <p>
            If, for any reason, a court of competent jurisdiction finds any provision of the TOS, or any portion thereof, to be unenforceable, that provision will be enforced to the maximum extent permissible so as to effect the intent of the TOS, and the remainder of the TOS will remain in full force and effect. If any provision renders the TOS in part or as a whole invalid, illusory, void, or otherwise ineffective, that provision shall be modified or stricken to render the TOS fully enforceable. The TOS are the entire agreement between you and HOST relating to the WEBSITE. Any other agreements between you and HOST regarding the subject matter of the TOS are superseded and have no force or effect. All rights not expressly granted herein are reserved.
          </p>

          <h5 className={classes.boldPara} style={{paddingBottom:"50px"}}>BY USING THE WEBSITE, OR INDICATING YOUR ASSENT BY CLICKING “I AGREE,” YOU ACCEPT THE TOS.
          </h5>
        </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default PrivacyPolicy;
//End PrivacyPolicy component code ...